import React from 'react';
import {usePage} from "@inertiajs/inertia-react";
import styles from "../../sass/components/ProductLogo.module.scss";

export default function ProductLogo() {
    const platformAssetsUrl = usePage().props.platformAssetsUrl;

    return (
        <div className={styles.logo + " amplify-logo"}>
            <img data-testid="product_log-img" className={styles.logoImg} src={ platformAssetsUrl + "/dashboard-logo.svg" } alt="product logo" />
        </div>
    )
}
